<template>
  <div class="view-player">
    <vue-plyr>
      <video ref="video" poster="@/assets/img/exercicies/words-attack/intro.png" :src="exercise.video" @playing="play" @pause="pause" @timeupdate="timeUpdated" class="video">
      </video>
    </vue-plyr>
  </div>
</template>
<script>
import 'vue-plyr/dist/vue-plyr.css'

export default {
  name: "VideoPlayer",
  data () {
    return {
      controls: [
        'restart',
        'play',
        'progress',
        'current-time',
        'duration',
        'volume'
      ],
      loaded: false,
      isPlaying: false,
      duration: 0,
      currentTime: 0,
      oldTime: null,
      volume: 1,
      ended: false,
      interruption: null,
      answered: false,
      first: true
    }
  },
  methods: {
    play () {
      if (!this.first) {
        if (!this.ended) {
          if (!this.answered) {
            this.pause()
            alert('Answer first!')
            return
          }
        }
      }
      this.isPlaying = true
      return this.$refs['video'].play()
    },
    end () {
      this.ended = true
    },
    answer () {
      this.answered = true
      this.first = true
    },
    setInterruption (time) {
      this.answered = false
      this.interruption = parseFloat(time)
    },
    timeUpdated () {
      const time = this.getCurrentTime()
      if (this.oldTime === null) this.oldTime = time
      else this.oldTime = this.currentTime
      this.currentTime = time
      if (this.interruption >= 0 && this.interruption !== null) {
        if ((this.interruption >= this.oldTime) && (this.interruption <= this.currentTime)) {
          if (this.first) this.first = false
          this.pause()
        }
      }
    },
    getCurrentTime () {
      return this.$refs['video'] ? this.$refs['video'].currentTime : 0
    },
    pause () {
      this.$refs['video'].pause()
      this.isPlaying = false
    }
  },
  props: {
    exercise: {
      type: Object,
      default: _ => ({})
    }
  }
}
</script>
<style lang="scss" scoped>
.view-player {
  width: 100%;
  height: 100%;
}

.video {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/game/GameComponents/VideoPlayer.vue